"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Paginator = function Paginator(_ref) {
  var hasMore = _ref.hasMore,
    page = _ref.page,
    prev = _ref.prev,
    next = _ref.next;
  if (page === 0 && !hasMore) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-search__panel-search-results-paginator"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "link",
    disabled: page === 0,
    onClick: prev
  }, "Previous"), /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "link",
    disabled: !hasMore,
    onClick: next
  }, "Next"));
};
var _default = Paginator;
exports.default = _default;